export default __webpack_public_path__ + "static/media/order-placed.30c8e0ea.svg";